@if (rootModel()) {
<div class="import-tree">
    <span #menuTrigger style="position: fixed" [matMenuTriggerFor]="menu" [style.left]="menuPosition.x + 'px'"
        [style.top]="menuPosition.y + 'px'"></span>
    <app-import-node [model]='rootModel()'></app-import-node>
    <mat-menu #menu="matMenu">
        <ng-template matMenuContent let-component="component" let-menu="menu">
            <button mat-menu-item [disabled]="!menu.realm" (click)="onRealm()">
                <mat-icon>cloud_circle</mat-icon>
                <span>New Realm</span>
            </button>
            <button mat-menu-item [disabled]="!menu.endpoint" (click)="onEndpoint()">
                <mat-icon>cloud_download</mat-icon>
                <span>Add Endpoint</span>
            </button>
            <button mat-menu-item [disabled]="!menu.syndicate" (click)="onSyndicate()">
                <mat-icon>rule_folder</mat-icon>
                <span>New Syndicate</span>
            </button>
            <button mat-menu-item [disabled]="!menu.cast" (click)="onCast()">
                <mat-icon>rule</mat-icon>
                <span>Add Cast</span>
            </button>
            <button mat-menu-item [disabled]="!menu.delete" (click)="onDelete(current)">
                <mat-icon>close</mat-icon>
                <span>Delete</span>
            </button>
            <button mat-menu-item [disabled]="!menu.cut" (click)="onCut(current)">
                <mat-icon>flip_to_front</mat-icon>
                <span>Cut</span>
            </button>
            <button mat-menu-item [disabled]="!menu.copy" (click)="onCopy(current)">
                <mat-icon>flip_to_back</mat-icon>
                <span>Copy</span>
            </button>
            <button mat-menu-item [disabled]="!menu.paste" (click)="onPaste()">
                <mat-icon>library_add</mat-icon>
                <span>Paste</span>
            </button>
        </ng-template>
    </mat-menu>
</div>
}
